var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCrossedBullhorn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.30079 5.33325L2.12573 2.15821L2.12574 2.1582L1.30078 2.98316L3.65087 5.33325H2.95073C2.59711 5.33325 2.25797 5.47373 2.00792 5.72378C1.75787 5.97383 1.6174 6.31296 1.6174 6.66659V9.33325C1.6174 9.68688 1.75787 10.026 2.00792 10.2761C2.25797 10.5261 2.59711 10.6666 2.95073 10.6666H3.6174V13.3333C3.6174 13.5101 3.68764 13.6796 3.81266 13.8047C3.93768 13.9297 4.10725 13.9999 4.28406 13.9999H5.6174C5.79421 13.9999 5.96378 13.9297 6.0888 13.8047C6.21383 13.6796 6.28406 13.5101 6.28406 13.3333V10.6666H8.28406L11.6174 13.3333V13.2998L13.5573 15.2397L14.3822 14.4147L11.6174 11.6499L5.30079 5.33325ZM11.6174 9.99996L6.95069 5.33325H8.28406L11.6174 2.66659V9.99996ZM14.6174 7.99992C14.6174 9.13992 13.9774 10.1733 12.9507 10.6666V5.33325C13.9707 5.83325 14.6174 6.86659 14.6174 7.99992Z",
    fill: "black",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossedBullhorn);
export default __webpack_public_path__ + "static/media/crossedBullhorn.dd754da9d6f0d2f673afab8471a889f6.svg";
export { ForwardRef as ReactComponent };